import React from 'react';
import { checkSize, checkColor } from './svg.helper';

export function add(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
      data-testid="ads-icon__svg"
    >
      <path
        d="M18 11h-5V6a1 1 0 00-2 0v5H6a1 1 0 000 2h5v5a1 1 0 002 0v-5h5a1 1 0 000-2z"
        fill={checkColor(color)}
        fillRule="nonzero"
        data-testid="ads-icon__path"
      />
    </svg>
  );
}

export function addCircleFilled(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12 3a9 9 0 11-.001 18.001A9 9 0 0112 3zm4 8h-3V8a1 1 0 00-2 0v3H8a1 1 0 000 2h3v3a1 1 0 002 0v-3h3a1 1 0 000-2z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function addCircleUnfilled(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12 3a9 9 0 11-.001 18.001A9 9 0 0112 3zm0 2a7 7 0 100 14 7 7 0 000-14zm0 2a1 1 0 011 1v3h3a1 1 0 010 2h-3v3a1 1 0 01-2 0v-3H8a1 1 0 010-2h3V8a1 1 0 011-1z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function autoFill(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M7.421 6.004h7.722a1.001 1.001 0 100-2.004H5.003A1.01 1.01 0 004 5.002v10.142a1.002 1.002 0 002.004 0V7.42L18.29 19.706a1 1 0 001.417 0 1 1 0 000-1.417L7.421 6.004z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function camera(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M13.895 3c1.272 0 2.39.76 2.922 1.903.08.174.24.292.425.292h.547c2.326 0 4.211 1.97 4.211 4.398v7.009c0 1.606-.825 3.012-2.056 3.78a4.063 4.063 0 01-2.155.618H6.212C3.886 21 2 19.031 2 16.602v-7.01c0-2.428 1.886-4.397 4.212-4.397h.547a.477.477 0 00.425-.292C7.716 3.761 8.834 3 10.106 3zm-.441 2h-2.908c-.93 0-1.723.703-1.88 1.665l-.013.081a.461.461 0 01-.448.397H6.384C5.068 7.143 4 8.265 4 9.648v6.847C4 17.878 5.068 19 6.384 19h11.233C18.932 19 20 17.878 20 16.495V9.648c0-1.383-1.068-2.504-2.383-2.504h-1.821a.464.464 0 01-.45-.398l-.012-.08C15.176 5.703 14.384 5 13.454 5zM12 8a5 5 0 11-.001 10.001A5 5 0 0112 8zm0 2a3 3 0 100 6 3 3 0 000-6z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function cameraFlip(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M13.895 3c1.272 0 2.39.76 2.922 1.903.08.174.24.292.425.292h.547c2.326 0 4.211 1.97 4.211 4.398v7.009c0 1.606-.825 3.012-2.056 3.78a4.063 4.063 0 01-2.155.618H6.212C3.886 21 2 19.031 2 16.602v-7.01c0-2.428 1.886-4.397 4.212-4.397h.547a.477.477 0 00.425-.292C7.716 3.761 8.834 3 10.106 3zm-.441 2h-2.908c-.93 0-1.723.703-1.88 1.665l-.013.081a.461.461 0 01-.448.397H6.384C5.068 7.143 4 8.265 4 9.648v6.847C4 17.878 5.068 19 6.384 19h11.233C18.932 19 20 17.878 20 16.495V9.648c0-1.383-1.068-2.504-2.383-2.504h-1.821a.464.464 0 01-.45-.398l-.012-.08C15.176 5.703 14.384 5 13.454 5zm-5.267 5.748l1.533 1.54c.118.11.054.33-.11.33h-.876c0 1.76 1.37 3.081 3.287 3.081.708-.009 1.477-.438 2.028-.825.256-.181.504-.145.735.069l.516.478c.32.296.235.673-.101.938-.767.605-2.191 1.21-3.849.997a5.416 5.416 0 01-4.697-4.738h-.987c-.163.001-.219-.22-.11-.33l1.535-1.54c.329-.33.767-.33 1.096 0zm4.563-4.004a5.416 5.416 0 014.697 4.738h.987c.163-.001.219.22.11.33l-1.535 1.54c-.329.33-.767.33-1.096 0l-1.533-1.54c-.118-.11-.054-.33.11-.33h.876c0-1.76-1.37-3.081-3.287-3.081-.708.009-1.477.438-2.028.825-.256.181-.504.145-.735-.069L8.8 8.68c-.32-.296-.235-.673.101-.938.767-.605 2.191-1.21 3.849-.997z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function change(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M8.954 5.4c.694 0 1.34.342 1.687.928l.942 1.562c.755 1.201 2.054 1.844 3.517 2.21.8.2.95.9.85 1.3-.1.4-.605.798-1.2.7-1.717-.273-3.196-1.115-4.258-2.404L10 12.7l1.35 1.3c.377.361.65.832.65 1.35V21c0 .537-.516 1-1.062 1-.545 0-.938-.463-.938-1v-5l-2.187-1.812L6.25 21.3c-.1.45-.501.7-.968.7h-.089c-.625 0-1.112-.595-.993-1.2L6.721 8.232 5 9v2c0 .537-.454 1-1 1s-1-.463-1-1V9c0-.79.486-1.55 1.23-1.852l3.98-1.602a2.03 2.03 0 01.744-.146zM19 17.246c0-.25.32-.326.5-.15l1.4 1.2c.11.108.11.292 0 .4l-1.4 1.2c-.172.169-.5.093-.5-.15v-.75h-4v-1h4zM15.483 14.1c.172-.169.5-.093.5.15V15h4v1h-4v.75c0 .25-.321.326-.5.15l-1.4-1.2a.284.284 0 010-.4zM10.5 2c.825 0 1.5.675 1.5 1.5S11.325 5 10.5 5 9 4.325 9 3.5 9.675 2 10.5 2z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function collapseLg(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M22 12a1 1 0 01-1.001 1H3.001a1 1 0 110-2h17.998A1 1 0 0122 12z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function deleteIcon(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M19 7l-1 13a1 1 0 01-1 1H7a1 1 0 01-1-1L5 7h14zm-2 2H7l.8 10h8.4L17 9zm2-5a1 1 0 010 2H5a1 1 0 010-2h5a1 1 0 011-1h2a1 1 0 011 1h5z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function edit(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M14.828 6.343l2.829 2.829-9.9 9.9H4.93v-2.83l9.9-9.899zm2.122-2.121a1 1 0 011.414 0l1.414 1.414a1 1 0 010 1.414l-1.414 1.414-2.828-2.828 1.414-1.414z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function editTag(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M11.025 3a.994.994 0 01.708.29l5.451 5.469-1.414 1.41L10.6 5H4.994L5 10.7l8 7.95 5.35-5.397 1.663-1.658.692.695a1 1 0 010 1.42l-7.038 7.03A.921.921 0 0113 21a1.07 1.07 0 01-.739-.29l-8.972-9A1.003 1.003 0 013 11.07V4c0-.552.446-1 .997-1h7.028zm7.868 5.468l1.424 1.412-5.876 5.859-1.434.02.01-1.432 5.876-5.86zm1.414-1.412a1.001 1.001 0 011.414 1.412l-.712.71-1.414-1.411zM7 6a1 1 0 110 2 1 1 0 010-2z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function enlarge(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M4 12a1 1 0 011 1v4.512l4.467-4.467a1 1 0 011.414 1.414L6.34 19H11a1 1 0 010 2H4a1 1 0 01-1-1v-7a1 1 0 011-1zm16-9a1 1 0 011 1v7a1 1 0 01-2 0V6.488l-4.467 4.467a1 1 0 01-1.414-1.414L17.66 5H13a1 1 0 010-2h7z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function expand(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12.001 2a1 1 0 011 1v7.988l7.999.001a1 1 0 01.993.883l.007.119a1 1 0 01-1 1l-7.999-.001V21a1 1 0 01-.883.993l-.119.007a1 1 0 01-1-1l-.001-8.01L3 12.991a1 1 0 01-.993-.883L2 11.989a1 1 0 011-1l7.998-.001L10.999 3a1 1 0 01.883-.993L12.001 2z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function filter(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M7 8c0 .74-.402 1.387-1 1.732V20a1 1 0 01-2 0V9.732a1.997 1.997 0 010-3.464V4a1 1 0 012 0v2.268C6.598 6.613 7 7.26 7 8zM6 8a1 1 0 10-2 0 1 1 0 002 0zm8 4c0 .74-.402 1.387-1 1.732V20a1 1 0 01-2 0v-6.268a1.997 1.997 0 010-3.464V4a1 1 0 012 0v6.268c.598.345 1 .992 1 1.732zm-1 0a1 1 0 10-2 0 1 1 0 002 0zm8 4c0 .74-.402 1.387-1 1.732V20a1 1 0 01-2 0v-2.268a1.997 1.997 0 010-3.464V4a1 1 0 012 0v10.268c.598.345 1 .992 1 1.732zm-1 0a1 1 0 10-2 0 1 1 0 002 0z"
        fill={checkColor(color)}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function menu(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M20 15.998a1 1 0 011 1V17a1 1 0 01-1 1H4a1 1 0 01-1-1v-.002a1 1 0 011-1h16zm-.02-5.014a1 1 0 011 1v.002a1 1 0 01-1 1H4.04a1 1 0 01-1-1v-.002a1 1 0 011-1h15.94zM19.99 6a.99.99 0 01.99.99v.002a.99.99 0 01-.99.99H4.01a.99.99 0 01-.99-.99V6.99A.99.99 0 014.01 6h15.98z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function minimize(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M4 12h7a1 1 0 011 1v7a1 1 0 01-2 0v-4.512l-4.467 4.467a1 1 0 01-1.414-1.414L8.66 14H4a1 1 0 010-2zm9-9a1 1 0 011 1v4.512l4.467-4.467a1 1 0 011.414 1.414L15.34 10H20a1 1 0 010 2h-7a1 1 0 01-1-1V4a1 1 0 011-1z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function moreHorizontal(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12 10a2 2 0 11.001 3.999A2 2 0 0112 10zm-8 0a2 2 0 11.001 3.999A2 2 0 014 10zm16 0a2 2 0 11.001 3.999A2 2 0 0120 10z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function moreHorizontalSm(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12 11a1.4 1.4 0 110 2.8 1.4 1.4 0 010-2.8zm-5.6 0a1.4 1.4 0 110 2.8 1.4 1.4 0 010-2.8zm11.2 0a1.4 1.4 0 110 2.8 1.4 1.4 0 010-2.8z"
        fill={checkColor(color)}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function moreVertical(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M10 12.1a2 2 0 113.999-.001A2 2 0 0110 12.1zm0 7.9a2 2 0 113.999-.001A2 2 0 0110 20zm0-16a2 2 0 113.999-.001A2 2 0 0110 4z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function move(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17.996 7.421v7.722a1.001 1.001 0 102.004 0V5.003A1.01 1.01 0 0018.998 4H8.856a1.002 1.002 0 000 2.004h7.724L4.294 18.29a1 1 0 000 1.417 1 1 0 001.417 0L17.996 7.421z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function punchout(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M20 15.527c.55 0 1 .45 1 1V19a1.995 1.995 0 01-2.001 2.001H5a1.995 1.995 0 01-2-2.002V5.001c0-.17.019-.34.07-.5C3.29 3.63 4.07 3 5.001 3h2.401c.55 0 1.001.451 1.001 1 0 .552-.45 1.001-1 1.001H5v13.998h14v-2.471c0-.55.45-1 1-1zM18.998 3.001A1.993 1.993 0 0121 5v5.003c0 .55-.44 1-1 1-.552 0-1.001-.45-1.001-1V6.412l-9.155 9.165c-.2.2-.45.29-.71.29-.25 0-.51-.09-.702-.29a.978.978 0 010-1.41l9.156-9.165h-3.592c-.551 0-1-.45-1-1.001 0-.55.449-1 1-1H19z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function refresh(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17.821 5.177c.229-.098.5-.113.75-.019l2.623 1.059a1 1 0 01.63.915c.004.404-.227.786-.599.945l-.923.392.1.248a8.998 8.998 0 01-4.869 11.55 8.961 8.961 0 01-5.944.383 1 1 0 01.54-1.926 7 7 0 008.375-9.369l-.043-.105-.918.39c-.332.14-.71.094-.992-.118l-.1-.087a1 1 0 01-.222-1.089l1.06-2.622a.986.986 0 01.532-.547zm-3.59-1.868a1 1 0 01-.507 1.935 7.001 7.001 0 00-8.211 9.514l.045.104.911-.406c.33-.145.709-.106.994.101l.102.086c.293.28.388.707.24 1.084l-1.014 2.64a.981.981 0 01-.522.557 1.014 1.014 0 01-.75.031l-2.64-1.012a1.013 1.013 0 01-.064-1.86l.916-.408-.105-.246A9.001 9.001 0 0114.23 3.309z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function remove(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <rect
        width="2"
        height="16"
        x="11"
        y="4"
        rx="1"
        transform="rotate(90 12 12)"
        fill={checkColor(color)}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function returnIcon(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M7.903 6.693a1 1 0 011.415 1.414l-2.979 2.978H19v-3a1.001 1.001 0 012 0v4a1 1 0 01-.883.994l-.117.007-13.587-.001 2.905 2.904a1 1 0 01-1.415 1.414l-4.596-4.596a.999.999 0 01-.286-.927.989.989 0 01.286-.59z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function search(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M10 3a7 7 0 015.607 11.191l5.1 5.102a1 1 0 01-1.414 1.414l-5.102-5.1A7 7 0 1110 3zm0 2a5 5 0 10.001 10.001A5 5 0 0010 5z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function settings(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M13.705 2c.906.01 1.697.6 1.946 1.45l.45 1.55 1.619-.39a2.069 2.069 0 012.284.94l1.72 2.91a1.965 1.965 0 01-.317 2.41L20.26 12l1.126 1.15c.643.642.768 1.623.307 2.4l-1.72 2.91a2.069 2.069 0 01-2.294.94l-1.577-.4-.41 1.54c-.248.865-1.057 1.462-1.977 1.46h-3.44a2.04 2.04 0 01-1.936-1.47L7.909 19l-1.608.39a2.068 2.068 0 01-2.294-.94l-1.72-2.91a1.963 1.963 0 01.306-2.4L3.74 12l-1.147-1.13a1.966 1.966 0 01-.317-2.41l1.761-2.92a2.069 2.069 0 012.284-.94L7.91 5l.389-1.53C8.542 2.601 9.352 2 10.274 2zm.006 2h-3.453l-.763 2.69a6.032 6.032 0 00-.98.55l-2.793-.69L4 9.45l2.062 2v1.09L4 14.54l1.742 2.93 2.794-.71c.302.208.623.39.959.54l.763 2.7h3.453l.804-2.71c.337-.15.658-.332.96-.54l2.793.71L20 14.55l-2.062-2v-1.09l2.062-2-1.732-2.91-2.794.69a6.032 6.032 0 00-.98-.55L13.712 4zM12 8c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm0 2a2 2 0 10-.001 3.999A2 2 0 0012 10z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function share(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17 12.5a1 1 0 010-2h3a1 1 0 011 1v9a1 1 0 01-1 1H4a1 1 0 01-1-1v-9a1 1 0 011-1h3a1 1 0 010 2l-2-.001V19.5h14v-7l-2 .001zm-.32-5.999a1.002 1.002 0 01-1.38 1.45L13 5.801v9.7a1 1 0 01-2 0V5.78L8.7 7.96A1.008 1.008 0 017.31 6.5l4-3.73a1.002 1.002 0 011.37 0z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function signIn(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M19 3a1 1 0 011 1v16a1 1 0 01-1 1h-7a1 1 0 010-2h6V5h-6a1 1 0 010-2h7zm-7 4.32l3.73 4a1 1 0 010 1.37l-3.73 4a1.001 1.001 0 01-1.46-1.37L12.7 13H5a1 1 0 010-2h7.69l-2.15-2.3A1.005 1.005 0 0112 7.32z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function signOut(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M19 3a1 1 0 011 1v16a1 1 0 01-1 1h-7a1 1 0 010-2h6V5h-6a1 1 0 010-2h7zM8.001 7.32a1.002 1.002 0 011.45 1.38L7.301 11h7.7a1 1 0 010 2H7.28l2.18 2.3A1.008 1.008 0 018 16.69l-3.73-4a1.002 1.002 0 010-1.37z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function subtractCircleFilled(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M3 12a9 9 0 1118.001.001A9 9 0 013 12zm13.99 0a1 1 0 00-1-1h-8a1 1 0 000 2h8a1 1 0 001-1z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function subtractCircleUnfilled(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12 3a9 9 0 11-.001 18.001A9 9 0 0112 3zm0 2a7 7 0 100 14 7 7 0 000-14zm3.99 6a1 1 0 010 2h-8a1 1 0 010-2h8z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function subtractSm(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17 12a1 1 0 01-1 1H8a1 1 0 010-2h8a1 1 0 011 1z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}
